import UsersPage from "components/pages/UsersPage";

/**
 * @name CaptureUsersDefault
 * @returns {React.Component}
 * @description 
 */
export default function CaptureUsersDefault(props) {

    return <UsersPage />;
}